/************************************** THIRD-PARTY MODULES ***************************************/
import * as envVarHelpers from 'env-var-helpers';
const {isDevelopment} = envVarHelpers;

import React from 'react';
import ReactDOM from 'react-dom';
import * as ReactRouterDOM from 'react-router-dom';

import ReactLadda from 'react-ladda';
import ReactDocumentTitle from 'react-document-title';
import ReactDDMenu from 'react-dd-menu';
import recompose from 'recompose';

import mobx from 'mobx';
import MobxReactDevtools from 'mobx-react-devtools';
import moment from 'moment';
import mobxReact from 'mobx-react';
import Kotlin from 'kotlin';
import cn from 'classnames';

import Javelin from '@canimmunize/javelinscript';
import * as CoreImports from '@canimmunize/core-imports';

import axios from 'axios';
import Cookies from 'js-cookie';

import {madUtils} from 'mad-utils/lib/react';

/**************************************** PROJECT MODULES *****************************************/
import * as Models from '../models/models';
import {config, devNS} from '../helpers/config-utils';

/******************** ADD ALL TO GLOBAL __DEV__ NAMESPACE IN DEVELOPMENT MODE *********************/
/**
 * Create global dev namespace (default: `__DEV__`) on window object containing
 * collection of useful libraries, the model/store classes, the global app
 * config, and Javelin/Javelinscript (Javelin)
 */
export const attachDevModeGlobals = () => {
    if (!isDevelopment || typeof window !== `object` || window === null) return;

    // Attach libraries, Javelin engine, and global configuration
    window[devNS] = {
        // Attach client config to global __DEV__ namespace
        config,

        // Attach Javelin/Javelin/Javelinscript engine
        Javelin,

        // Attach actual libraries to the global __DEV__ namespace
        lib: {
            // Attach project imports
            CoreImports,

            // Attach util libs
            axios,
            Cookies,
            classnames: cn,
            fetch,
            moment,
            recompose,

            // Kotlin-related
            Kotlin: {
                all: Kotlin,
                collections: Kotlin.kotlin.collections,
                HashMap: Kotlin.kotlin.collections.HashMap,
                ArrayList: Kotlin.kotlin.collections.ArrayList,
            },
            madUtils,
            envVarHelpers,

            // Attach mobX itself
            mobx,
            mobxReact,
            MobxReactDevtools,

            // Attach React itself
            React,
            ReactDOM,

            // Attach React plugin libraries
            ReactPlugins: {
                ReactDocumentTitle,
                ReactDDMenu,
                ReactLadda,
                ReactRouterDOM,
            },
        },

        // Attach model objects to global __DEV__ namespace
        Models,
    };

    // Attach lodash if present
    if (window[`lodash`]) {
        window[devNS].lib._ = window[`lodash`];
        window[devNS].lib.lodash = window[`lodash`];
    } else if (window[`_`]) {
        window[devNS].lib._ = window[`_`];
        window[devNS].lib.lodash = window[`_`];
    }

    // Attach polyglot if present
    if ((window as any).Polyglot) window[devNS].lib.Polyglot = (window as any).Polyglot;

    (window as any).Javelin = Javelin;

    return window[devNS];
};

/**
 * Bind application state store to top of dev namespace
 */
export const bindAppStateToDevGlobals = () => {
    if (!isDevelopment) return;
    const rootStore = window[devNS].Models.Store.instance;

    if (rootStore) {
        Reflect.set(window[devNS], `appState`, rootStore);
        if (rootStore.javelinDataStore) {
            Reflect.set(window[devNS], `javelinState`, rootStore.javelinDataStore);
        }
    }
};
